import { BaseURl } from "./BaseApiUrl";

// https://testcockpit.p2k.in/api/woDetails/repGetCompletedWoList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&startDate=04/04/2026&endDate=05/04/2026
export const getRepCompletedWorkOrderListAPIURL = BaseURl + "woDetails/repGetCompletedWoList/v1/";